import { useSearchParams } from 'react-router';

import { FeatureParams } from './useFeatureParams.ts';

export const useFeatureParamsLocation = () => {
    const [searchParams] = useSearchParams();

    const filteredSearchParams = new URLSearchParams();
    const featureParams = Object.values(FeatureParams);
    for (const [key, value] of searchParams.entries()) {
        if (featureParams.includes(key) && value === 'true') {
            filteredSearchParams.set(key, value);
        }
    }
    const filteredParams = filteredSearchParams.toString();
    return filteredParams ? `?${filteredParams}` : '';
};
